import { render } from "./MyPageWrapper.vue?vue&type=template&id=f10cfc76&ts=true"
import script from "./MyPageWrapper.vue?vue&type=script&lang=ts"
export * from "./MyPageWrapper.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__